module.exports = __webpack_public_path__ + "static/media/ic_calendar.f52dbbfd.svg";